import { BaseWindowViewScope } from '../base/BaseWindowViewScope';
import { SecondScopeInfo } from '../../scope/SecondScopeInfo';

/**
 * PayPay決済完了後ビュー情報
 */
export class PayPayRedirectComponentView extends BaseWindowViewScope<SecondScopeInfo> {
	// コンストラクタ  -----------------------------------------------------------
	public constructor() {
		super('step7_paypay');
	}
	// --------------------------------------------------------------------------

	// override メソッド  --------------------------------------------------------
	/**
	 * ビュー表示通知
	 */
	public onShowView(): void {
		this.refreshView();
	}
	// --------------------------------------------------------------------------
}
